"use client";

import { useSyncExternalStore } from "react";

const noopSubscribe = () => () => {};

/**
 * False on the server and during hydration, true afterwards. Use it to
 * defer markup that cannot match between server and client - Radix
 * components whose generated ids (aria-controls) diverge, or anything read
 * from browser storage.
 */
export function useHydrated(): boolean {
  return useSyncExternalStore(
    noopSubscribe,
    () => true,
    () => false,
  );
}
